import * as _ from 'underscore';
import React from 'react';
import { connect } from 'react-redux';

import PlusIcon from '@material-ui/icons/PlaylistAdd';

import HDrawer from '../../../common/HDrawer';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import { ExerciseCreateEdit } from '../ExerciseCreateEdit';
import { isLift, TRAINHEROIC_USER_ID } from '../../../../lib/exerciseUtils';
import { FEATURES } from '../../../../v5/features/components/constants';
import { paramTypes, workoutParamTypes } from '../../../../lib/paramTypes';

import Console from '../../../../lib/debug';

export class ExerciseCreateDrawerClass extends React.Component {
    handleClose = () => {
        const block = this.props.block;
        const exercise = this.props.exercise;
        const isOpen = false;
        DesignerState.toggleExerciseDialog(block, exercise, isOpen);
    };

    handleSave = newExercise => {
        const block = this.props.block;
        const setExercise = this.props.setExercise;
        DesignerState.saveAndAddExercise(block, setExercise, newExercise);
    };

    isExerciseTrainHeroic = exercise => {
        return exercise.user_id === TRAINHEROIC_USER_ID;
    };

    isExerciseTrainHeroicLift = exercise => {
        return isLift(exercise) && this.isExerciseTrainHeroic(exercise);
    };

    reportingExercises = () => {
        const reportingExercises = _.filter(
            this.props.exerciseRef,
            this.isExerciseTrainHeroic
        );
        return this.sortExercisesByTitle(reportingExercises);
    };

    referenceMaxExercises = () => {
        const referenceMaxExercises = _.filter(
            this.props.exerciseRef,
            this.isExerciseTrainHeroicLift
        );
        return this.sortExercisesByTitle(referenceMaxExercises);
    };

    sortExercisesByTitle = exercises => {
        return _.sortBy(exercises, 'title');
    };

    defaultSetExercise = () => {
        return {
            title: '',
            can_edit: 1,
            eType: 'e'
        };
    };

    setExercise = () => {
        const setExercise = this.props.setExercise || {};
        const defaultSetExercise = this.defaultSetExercise();
        return { ...defaultSetExercise, ...setExercise };
    };

    render() {
        Console.render('ExerciseCreateEditDrawer');
        return (
            <HDrawer
                open={this.props.newExerciseDialog}
                onClose={this.handleClose}
                title="Create Exercise"
                subTitle=""
                icon={<PlusIcon />}
            >
                <ExerciseCreateEdit
                    tagList={this.props.exerciseTags}
                    exercise={this.setExercise()}
                    tags={this.props.exerciseTags}
                    exerciseRef={this.props.exerciseRef}
                    onClose={this.handleClose}
                    onSave={this.handleSave}
                    isSidenav={true}
                    referenceMaxExercises={this.referenceMaxExercises()}
                    reportingExercises={this.reportingExercises()}
                    pickerParamTypes={this.props.pickerParamTypes}
                />
            </HDrawer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const isRepRangeEnabled =
        state.features[FEATURES.WEB_PROGRAMMABLE_REP_RANGE_TYPE_V1];
    const pickerParamTypes = isRepRangeEnabled
        ? paramTypes
        : paramTypes.filter(t => t.id !== workoutParamTypes.REP_RANGE);
    return {
        block: state.calendar.uiTree.block,
        createNewDialog: !!state.calendar.uiTree.createNew,
        exercise: state.calendar.uiTree.exercise,
        exerciseRef: state.library.exerciseRef,
        exerciseTags: state.calendar.uiTree.exerciseTags,
        newExerciseDialog: !!state.calendar.uiTree.newExerciseDialog,
        setExercise: state.calendar.uiTree.setExercise,
        pickerParamTypes,
        ...ownProps
    };
};

export default connect(mapStateToProps)(ExerciseCreateDrawerClass);
